import React from "react";
import { FaUser, FaBookOpen } from "react-icons/fa";
import "./Speakers.css";

import baillieImg from "../images/keynote/Sarah-Baillie.jpg";
import channonImg from "../images/keynote/Sarah-Channon.jpg";
import mashimaImg from "../images/keynote/ted_mashima.png";
import fassiFihriImg from "../images/scientific/ouafaa.png";
import elBerbriImg from "../images/executive/Ikhlass.jpeg";
import dhingraImg from "../images/conferenciers/madhur-dhingra.jpg";
import bengoumiImg from "../images/conferenciers/mohammed-bengoumi.jpg";
import abdelsattarImg from "../images/conferenciers/hana-abdelsattar.jpg";
import zakiImg from "../images/conferenciers/sanaa-zaki.png";

// Speakers per congress day, following the official scientific program
// (images/VetEd_Africa_Scientific_Program_VF.pdf). Speakers without a photo show a placeholder.
const PROGRAM_DAYS = [
  {
    day: "Day 1",
    date: "November 19, 2026",
    theme: "Training Global Professionals: Upskilling and International Vision as an Academic Challenge in Veterinary Medicine",
    speakers: [
      {
        name: "Dr. Sarah Baillie",
        affiliation: "CIVME, UK",
        image: baillieImg,
        sessions: [
          { label: "Keynote Lecture 1", topic: "Optimizing student learning of clinical skills" },
          { label: "Workshop 3", topic: "Setting up and running a clinical skills lab" },
        ],
      },
      {
        name: "Dr. Sarah Channon",
        affiliation: "CIVME, UK",
        image: channonImg,
        sessions: [
          { label: "Keynote Lecture 2", topic: "Teaching Veterinary Anatomy in 2026: what, how and how much?" },
          { label: "Workshop 2", topic: "Tools and approaches for teaching clinically integrated anatomy" },
        ],
      },
      {
        name: "Dr. Nihad Fejzić",
        affiliation: "CIVME, Bosnia and Herzegovina",
        sessions: [
          { label: "Keynote Lecture 3", topic: "Empty Barns, Overcrowded Clinics: Restoring Balance in Veterinary Education Priorities" },
        ],
      },
      {
        name: "Dr. A. Delgado",
        affiliation: "FAO, EMPRES",
        sessions: [
          { label: "Keynote Lecture 4", topic: "Machine Learning and Data Analytics for Animal Health Surveillance" },
        ],
      },
      {
        name: "Dr. F. Dorea",
        affiliation: "FAO, EMPRES",
        sessions: [
          { label: "Keynote Lecture 4", topic: "Machine Learning and Data Analytics for Animal Health Surveillance" },
        ],
      },
      {
        name: "Dr. C. Revie",
        affiliation: "FAO, EMPRES",
        sessions: [
          { label: "Keynote Lecture 4", topic: "Machine Learning and Data Analytics for Animal Health Surveillance" },
        ],
      },
      {
        name: "Dr. Ted Mashima",
        affiliation: "AAVMC, USA",
        image: mashimaImg,
        sessions: [
          { label: "Keynote Lecture 5", topic: "Navigating the AI Frontier: Modernizing Global Veterinary Education" },
        ],
      },
      {
        name: "Dr. Miftahul Islam Barbaruah",
        affiliation: "WOAH",
        sessions: [
          { label: "Workshop 1", topic: "From Veterinary Education to Workforce Excellence: an interactive dialogue across WOAH solutions for shaping the future veterinarians" },
        ],
      },
      {
        name: "Journal of Veterinary Medicine Education",
        isOrganization: true,
        sessions: [
          { label: "Workshop 4", topic: "Use of AI in educational scholarship" },
        ],
      },
    ],
  },
  {
    day: "Day 2",
    date: "November 20, 2026",
    theme: "Advancing One Health Strategies and Transboundary Diseases",
    speakers: [
      {
        name: "Dr. Madhur S. Dhingra",
        affiliation: "FAO, SNE",
        image: dhingraImg,
        sessions: [
          { label: "Keynote Lecture 1", topic: "One Health Approach for Emerging and Transboundary Animal Diseases" },
        ],
      },
      {
        name: "Dr. N. Lyons",
        affiliation: "FAO, SNE",
        sessions: [
          { label: "Keynote Lecture 1", topic: "One Health Approach for Emerging and Transboundary Animal Diseases" },
        ],
      },
      {
        name: "Prof. Mohammed Bengoumi",
        affiliation: "FAO, Morocco",
        image: bengoumiImg,
        sessions: [
          { label: "Keynote Lecture 1", topic: "One Health Approach for Emerging and Transboundary Animal Diseases" },
          { label: "Workshop 7", topic: "Risk Assessment and Preparedness for Transboundary Animal Diseases" },
        ],
      },
      {
        name: "Dr. Hana Abdelsattar",
        affiliation: "WOAH",
        image: abdelsattarImg,
        sessions: [
          { label: "Keynote Lecture 2", topic: "Advancing One Health through veterinary education: WOAH One Health Learning and Training initiatives" },
        ],
      },
      {
        name: "Dr. Ouafaa Fassi Fihri",
        affiliation: "IAV Hassan II, Morocco",
        image: fassiFihriImg,
        sessions: [
          { label: "Keynote Lecture 3", topic: "One Health Approaches to Emerging and Reemerging Diseases" },
        ],
      },
      {
        name: "Dr. Sanaa Zaki",
        affiliation: "SSVS University of Sydney, Australia",
        image: zakiImg,
        sessions: [
          { label: "Keynote Lecture 4", topic: "One Health And Public Health Communication: Global Considerations And Capacity Building For Veterinary Medical Education" },
        ],
      },
      {
        name: "Dr. I. Seck",
        affiliation: "FAO, EMPRES",
        sessions: [
          { label: "Keynote Lecture 5", topic: "Digital Surveillance Systems for Transboundary Animal Diseases" },
        ],
      },
      {
        name: "Dr. G. Gioia",
        affiliation: "FAO, EMPRES",
        sessions: [
          { label: "Keynote Lecture 5", topic: "Digital Surveillance Systems for Transboundary Animal Diseases" },
        ],
      },
      {
        name: "Prof. Bennis",
        affiliation: "UM6SS, Morocco",
        sessions: [
          { label: "Workshop 5", topic: "Building Integrated One Health Surveillance Systems" },
        ],
      },
      {
        name: "Prof. Diawara",
        affiliation: "UM6SS, Morocco",
        sessions: [
          { label: "Workshop 6", topic: "Molecular Epidemiology and Genomic Surveillance of Emerging Viruses" },
        ],
      },
    ],
  },
  {
    day: "Day 3",
    date: "November 21, 2026",
    theme: "Combating Antimicrobial Resistance",
    speakers: [
      {
        name: "Dr. Hassan Housni",
        affiliation: "FLI, Germany",
        sessions: [
          { label: "Keynote Lecture 1", topic: "Global Trends in Antimicrobial Resistance in Animal Production" },
        ],
      },
      {
        name: "Prof. Saadia Nassik",
        affiliation: "IAV Hassan II, Morocco",
        sessions: [
          { label: "Keynote Lecture 2", topic: "Alternatives to Antibiotics in Veterinary Medicine" },
        ],
      },
      {
        name: "Dr. Nadia Brik",
        affiliation: "WOAH, SRR NA",
        sessions: [
          { label: "Keynote Lecture 3", topic: "Antimicrobial Resistance and Food Safety: The Farm-to-Fork Perspective" },
          { label: "Workshop 8", topic: "Designing Antimicrobial Stewardship Programs in Veterinary Practice" },
        ],
      },
      {
        name: "Dr. Olatunji Nasir",
        affiliation: "Medicines Stewardship Working Group (WVA-WOAH)",
        sessions: [
          { label: "Workshop 8", topic: "Designing Antimicrobial Stewardship Programs in Veterinary Practice" },
        ],
      },
      {
        name: "Prof. Ikhlass El Berbri",
        affiliation: "IAV Hassan II, Morocco",
        image: elBerbriImg,
        sessions: [
          { label: "Workshop 9", topic: "Laboratory Methods for Detection of Antimicrobial Resistance" },
        ],
      },
      {
        name: "Prof. Najib Al Idrissi",
        affiliation: "UM6SS, Morocco",
        sessions: [
          { label: "Workshop 9", topic: "Laboratory Methods for Detection of Antimicrobial Resistance" },
        ],
      },
      {
        name: "Dr. Younès El Wahli",
        affiliation: "ONSSA, Morocco",
        sessions: [
          { label: "Workshop 9", topic: "Laboratory Methods for Detection of Antimicrobial Resistance" },
        ],
      },
    ],
  },
];

const SpeakerCard = ({ speaker }) => (
  <div className="speakers-card">
    <div className="speakers-photo">
      {speaker.image ? (
        <img src={speaker.image} alt={speaker.name} loading="lazy" />
      ) : (
        <div className="speakers-placeholder" aria-hidden="true">
          {speaker.isOrganization ? <FaBookOpen /> : <FaUser />}
        </div>
      )}
    </div>
    <h3 className="speakers-name">{speaker.name}</h3>
    {speaker.affiliation && <p className="speakers-affiliation">{speaker.affiliation}</p>}
    <ul className="speakers-sessions">
      {speaker.sessions.map((session) => (
        <li key={session.label}>
          <span className="speakers-session-label">{session.label}</span>
          <span className="speakers-session-topic">{session.topic}</span>
        </li>
      ))}
    </ul>
  </div>
);

const Speaker = () => {
  return (
    <div className="speakers-section">
      <h1 className="speakers-title">Speakers</h1>
      {PROGRAM_DAYS.map((day) => (
        <div key={day.day} className="speakers-day">
          <div className="speakers-day-header">
            <span className="speakers-day-badge">
              {day.day} · {day.date}
            </span>
            <h2 className="speakers-day-theme">{day.theme}</h2>
          </div>
          <div className="speakers-grid">
            {day.speakers.map((speaker) => (
              <SpeakerCard key={speaker.name} speaker={speaker} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Speaker;
